import API from '@/services/api';
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    list: [
      {
          "id": 34,
          "slug": "chatty",
          "sort_priority": 0,
          "title": "Chatty",
          "description": "Chatbot App for kids, built on the foundation of GPT chat",
          "created_at": "2024-03-29 12:26:18",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 225,
              "disk_name": "6606b3f281b8d566019074.png",
              "file_name": "cover.png",
              "file_size": 1748285,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 225,
              "created_at": "2024-03-29 12:28:34",
              "updated_at": "2024-03-29 12:28:36",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/660\/6b3\/f28\/6606b3f281b8d566019074.png",
              "extension": "png"
          }
      },
      {
          "id": 35,
          "slug": "budget-tracker",
          "sort_priority": 0,
          "title": "Budget Tracker",
          "description": "Application for family financial accounting",
          "created_at": "2024-03-29 13:48:52",
          "updated_at": "2024-03-30 08:47:18",
          "image": {
              "id": 229,
              "disk_name": "6606c756c5a64589911141.png",
              "file_name": "Cover.png",
              "file_size": 2066570,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 229,
              "created_at": "2024-03-29 13:51:18",
              "updated_at": "2024-03-29 13:51:20",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/660\/6c7\/56c\/6606c756c5a64589911141.png",
              "extension": "png"
          }
      },
      {
          "id": 33,
          "slug": "spherotek",
          "sort_priority": 1,
          "title": "Spherotek",
          "description": "Logo Design",
          "created_at": "2024-03-28 11:08:42",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 222,
              "disk_name": "66054ecb517dc484621522.png",
              "file_name": "spherotek.png",
              "file_size": 2636732,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 222,
              "created_at": "2024-03-28 11:04:43",
              "updated_at": "2024-03-28 11:08:42",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/660\/54e\/cb5\/66054ecb517dc484621522.png",
              "extension": "png"
          }
      },
      {
          "id": 32,
          "slug": "weekend-planner",
          "sort_priority": 2,
          "title": "Weekender",
          "description": "Unique weekend plans that reflect your preferences",
          "created_at": "2024-02-09 15:17:45",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 221,
              "disk_name": "65c6446a4dff0156928658.png",
              "file_name": "Cover_web.png",
              "file_size": 3496285,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 221,
              "created_at": "2024-02-09 15:27:38",
              "updated_at": "2024-02-09 15:30:15",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/65c\/644\/6a4\/65c6446a4dff0156928658.png",
              "extension": "png"
          }
      },
      {
          "id": 31,
          "slug": "intercom-design",
          "sort_priority": 3,
          "title": "Intercom Design",
          "description": "Everyday things should be easy",
          "created_at": "2024-02-09 08:49:43",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 219,
              "disk_name": "65c5e7886cb2f451346050.png",
              "file_name": "Web.png",
              "file_size": 1837343,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 219,
              "created_at": "2024-02-09 08:51:20",
              "updated_at": "2024-02-09 08:51:25",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/65c\/5e7\/886\/65c5e7886cb2f451346050.png",
              "extension": "png"
          }
      },
      {
          "id": 30,
          "slug": "ai-solution-detecting-falls",
          "sort_priority": 4,
          "title": "App for detecting falls",
          "description": "Designed to take care of your parents",
          "created_at": "2024-01-23 10:06:35",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 217,
              "disk_name": "65c5e56798ccf596376606.png",
              "file_name": "Web.png",
              "file_size": 2280720,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 217,
              "created_at": "2024-02-09 08:42:15",
              "updated_at": "2024-02-09 08:42:18",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/65c\/5e5\/679\/65c5e56798ccf596376606.png",
              "extension": "png"
          }
      },
      {
          "id": 29,
          "slug": "picturia",
          "sort_priority": 5,
          "title": "Picturia",
          "description": "Flutter based mobile app",
          "created_at": "2023-12-28 07:54:26",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 215,
              "disk_name": "658d29ac57025117274966.png",
              "file_name": "Web_cover_1.png",
              "file_size": 1817763,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 215,
              "created_at": "2023-12-28 07:54:20",
              "updated_at": "2023-12-28 07:54:26",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/658\/d29\/ac5\/658d29ac57025117274966.png",
              "extension": "png"
          }
      },
      {
          "id": 28,
          "slug": "fitness-app",
          "sort_priority": 6,
          "title": "Fitness App",
          "description": "Between Women's Health, Sport And The Future of AI",
          "created_at": "2023-12-27 18:58:21",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 214,
              "disk_name": "658d27bdafe28688689179.png",
              "file_name": "Web_cover_3.png",
              "file_size": 1185593,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 214,
              "created_at": "2023-12-28 07:46:05",
              "updated_at": "2023-12-28 07:46:09",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/658\/d27\/bda\/658d27bdafe28688689179.png",
              "extension": "png"
          }
      },
      {
          "id": 24,
          "slug": "trident-collection",
          "sort_priority": 7,
          "title": "Trident",
          "description": "NFT Art Collection",
          "created_at": "2023-11-01 13:32:49",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 205,
              "disk_name": "65425379bf038575309960.png",
              "file_name": "web_cover \u2013 1.png",
              "file_size": 2991016,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 205,
              "created_at": "2023-11-01 13:32:41",
              "updated_at": "2023-11-01 13:32:49",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/654\/253\/79b\/65425379bf038575309960.png",
              "extension": "png"
          }
      },
      {
          "id": 27,
          "slug": "fairy-land",
          "sort_priority": 8,
          "title": "Fairy Land",
          "description": "Gamification and AR",
          "created_at": "2023-11-06 18:30:33",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 211,
              "disk_name": "65493070a6758661012415.png",
              "file_name": "cover.png",
              "file_size": 1121451,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 211,
              "created_at": "2023-11-06 18:29:04",
              "updated_at": "2023-11-06 18:30:33",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/654\/930\/70a\/65493070a6758661012415.png",
              "extension": "png"
          }
      },
      {
          "id": 25,
          "slug": "weather-forecast",
          "sort_priority": 9,
          "title": "Weather Forecast",
          "description": "Progressive Web App Creation",
          "created_at": "2023-11-02 08:24:49",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 207,
              "disk_name": "6543605d75a32280053450.png",
              "file_name": "Web_cover (1).png",
              "file_size": 1929121,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 207,
              "created_at": "2023-11-02 08:39:57",
              "updated_at": "2023-11-02 08:40:00",
              "path": "https://uaserial.com/images/actors/65/652815c80dc33935054458.webp",
              "extension": "png"
          }
      },
      {
          "id": 26,
          "slug": "ai-demos-interfaces",
          "sort_priority": 10,
          "title": "AI Demos",
          "description": "Pose estimation, Text to Image: Contextual Avatar, NLP Text Analysis Demo",
          "created_at": "2023-11-02 11:18:04",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 210,
              "disk_name": "65438668e19e4875408293.png",
              "file_name": "Cover_web (2).png",
              "file_size": 522059,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 210,
              "created_at": "2023-11-02 11:22:16",
              "updated_at": "2023-11-02 11:22:19",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/654\/386\/68e\/65438668e19e4875408293.png",
              "extension": "png"
          }
      },
      {
          "id": 23,
          "slug": "art-united",
          "sort_priority": 11,
          "title": "Art United",
          "description": "Join us in our fight",
          "created_at": "2023-03-28 15:51:37",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 204,
              "disk_name": "64230d04b06cb340851078.png",
              "file_name": "web_cover.png",
              "file_size": 954742,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 204,
              "created_at": "2023-03-28 15:51:32",
              "updated_at": "2023-03-28 15:51:37",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/642\/30d\/04b\/64230d04b06cb340851078.png",
              "extension": "png"
          }
      },
      {
          "id": 22,
          "slug": "dopomoga-poruch",
          "sort_priority": 12,
          "title": "Dopomoga Poruch",
          "description": "Don't be ashamed to ask for help",
          "created_at": "2023-03-20 15:49:57",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 203,
              "disk_name": "641880a141718016175417.png",
              "file_name": "web_cover \u2013 1.png",
              "file_size": 2093206,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 203,
              "created_at": "2023-03-20 15:49:53",
              "updated_at": "2023-03-20 15:49:57",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/641\/880\/a14\/641880a141718016175417.png",
              "extension": "png"
          }
      },
      {
          "id": 13,
          "slug": "recycling-assistant",
          "sort_priority": 13,
          "title": "Recycling Assistant",
          "description": "Waste segregation using artificial intelligence",
          "created_at": "2023-02-24 16:04:11",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 193,
              "disk_name": "63f8df6bdca22356900723.jpg",
              "file_name": "Design_website_cover.jpg",
              "file_size": 1878253,
              "content_type": "image\/jpeg",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 193,
              "created_at": "2023-02-24 16:01:47",
              "updated_at": "2023-02-24 16:04:11",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/8df\/6bd\/63f8df6bdca22356900723.jpg",
              "extension": "jpg"
          }
      },
      {
          "id": 20,
          "slug": "ar-navigation",
          "sort_priority": 14,
          "title": "AR Navigation",
          "description": "App for navigation in a large office or campus",
          "created_at": "2023-02-27 11:07:24",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 201,
              "disk_name": "63fc8d6088497343332517.png",
              "file_name": "Cover.png",
              "file_size": 2636913,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 201,
              "created_at": "2023-02-27 11:00:48",
              "updated_at": "2023-02-27 11:07:24",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/c8d\/608\/63fc8d6088497343332517.png",
              "extension": "png"
          }
      },
      {
          "id": 17,
          "slug": "geoquora",
          "sort_priority": 15,
          "title": "GeoQuora",
          "description": "The new way explore the world",
          "created_at": "2023-02-24 19:08:05",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 198,
              "disk_name": "63f90d89415f1000489451.png",
              "file_name": "web_cover \u2013 1.png",
              "file_size": 601178,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 198,
              "created_at": "2023-02-24 19:18:33",
              "updated_at": "2023-02-24 19:18:35",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/90d\/894\/63f90d89415f1000489451.png",
              "extension": "png"
          }
      },
      {
          "id": 21,
          "slug": "concep-design",
          "sort_priority": 16,
          "title": "Concept Design",
          "description": "Mobile app for the music platform",
          "created_at": "2023-02-27 11:36:52",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 202,
              "disk_name": "63fc95982a8b8623818577.png",
              "file_name": "web_cover.png",
              "file_size": 4660664,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 202,
              "created_at": "2023-02-27 11:35:52",
              "updated_at": "2023-02-27 11:36:52",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/c95\/982\/63fc95982a8b8623818577.png",
              "extension": "png"
          }
      },
      {
          "id": 14,
          "slug": "qa-skill-",
          "sort_priority": 17,
          "title": "QA Skill-Up",
          "description": "Web application for testing the skills of a new QA engineer",
          "created_at": "2023-02-24 17:14:19",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 194,
              "disk_name": "63f8f067c1301259515144.png",
              "file_name": "web_cover.png",
              "file_size": 3153936,
              "content_type": "image\/png",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 194,
              "created_at": "2023-02-24 17:14:15",
              "updated_at": "2023-02-24 17:14:19",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/8f0\/67c\/63f8f067c1301259515144.png",
              "extension": "png"
          }
      },
      {
          "id": 18,
          "slug": "book-recipes",
          "sort_priority": 18,
          "title": "Book of Recipes",
          "description": "Your little assistant in the kitchen",
          "created_at": "2023-02-27 07:39:00",
          "updated_at": "2024-03-29 13:36:44",
          "image": {
              "id": 199,
              "disk_name": "63fc5e10bdf51576745872.jpg",
              "file_name": "Web Cover_text_upd.jpg",
              "file_size": 1110159,
              "content_type": "image\/jpeg",
              "title": null,
              "description": null,
              "field": "image",
              "sort_order": 199,
              "created_at": "2023-02-27 07:38:56",
              "updated_at": "2023-02-27 07:39:00",
              "path": "https:\/\/designers.mobidev.biz\/storage\/app\/uploads\/public\/63f\/c5e\/10b\/63fc5e10bdf51576745872.jpg",
              "extension": "jpg"
          }
      }
  ],
  },
  getters: {
    ['portfolio:get']: state => state.list,
  },
  mutations: {
    ['portfolio:set'](state, { data }) {
      state.list = data;
    },
  },
  actions: {
    async ['portfolio:fetch']({ commit }) {
      try {
        const portfolio = await API.getPortfolio();
        commit('portfolio:set', portfolio);
      } catch (err) {
        console.error(err);
      }
    },
    async ['portfolioDetails:fetch'](context, id) {
      try {
        return await API.getPortfolioDetails({ params: { id } });
      } catch (err) {
        console.error(err);
        return {};
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/portfolio/index.js